import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { BaseFormControlComponent } from '../../../classes/base-form-control.component';
import { CollectionFormField } from '../../../../../../../models/ts/collection-form-field.model';
import { formsActions } from '../../../../../../store/features/forms/forms-actions';
import { TooltipComponent } from '../../../../../../shared/components/ui/tooltip/tooltip.component';
import { DateTimePickerModule } from '@progress/kendo-angular-dateinputs';

@Component({
  selector: 'bizz-enum-list-control',
  standalone: true,
  imports: [CommonModule, ComboBoxModule, ReactiveFormsModule, TooltipComponent, DateTimePickerModule],
  templateUrl: './enum-list-control.component.html',
  styleUrls: ['./enum-list-control.component.scss']
})
export class EnumListControlComponent extends BaseFormControlComponent {

  public enumValue = computed(() => {
    let field = this.formFieldSignal();
    if (field !== undefined) {
      return field.EnumList?.find(e => e.Value == field?.EnumValue)?.Text ?? field.Value;
    } else return '';
  });

  protected override fieldValueProperty: keyof CollectionFormField = 'EnumValue';

  protected override fieldValueChangeComparator(previous: CollectionFormField | undefined, current: CollectionFormField | undefined): boolean {
    return current?.EnumValue == previous?.EnumValue;
  }

  protected override valueChangeDispatcher(value: any): void {
    const fieldId = this.formFieldSignal()?.Id;
    if (fieldId)
      this.store$.dispatch(formsActions.updateFormFieldEnumValue({
        formId: this.formId,
        fieldId: fieldId,
        value: value
      }));
  }

  protected override focus(): void {
    // Add your implementation here
  }
}
